import React, { useState } from "react";
import { useForm } from "react-hook-form";
import tvImage from "../../../assets/images/tataplay-tv-image.png";
import logo from "../../../assets/images/logo-updated.png";
import bottomshape from "../../../assets/images/tataplay-bottom.png";
import { Link, useNavigate } from "react-router-dom";
import Captcha from "../Captcha/Captcha";
import BasicModal from "../../core/BaseComponents/Modal";
import Axios from "axios";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { faAt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange'
  });

  const [apiError, setApiError] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [apiSuccessPopupOpen, setApiSuccessPopupOpen] = useState(false);

  const onSubmit = (data) => {
    Axios.get(
      `${process.env.REACT_APP_BASE_URL}/user/forgot-password?captchaText=${data.captchaText}&email=${data.userName}`,
      { withCredentials: true }
    )
      .then((response) => {
        setApiError("");
        setApiResponse(response?.data?.message);
        setApiSuccessPopupOpen(true);
      })
      .catch((error) => {
        console.warn(error);
        setApiResponse("");
        setApiError(error.response?.data?.errors);
      });
  };

  const popupCloseHandler = () => {
    setApiSuccessPopupOpen(false);
    navigate("/login");
  };

  return (
    <div className="login-container row">
      <div className="left-panel col-6">
        <div className="left-panel-tv-logo">
          <img src={tvImage} alt="left pannel setup box" />
        </div>
        <div className="left-panel-logo">
          <img src={logo} alt="login logo" />
        </div>
        <div className="left-panel-shape">
          <img src={bottomshape} alt="login bottom shape" />
        </div>
      </div>

      <div className="right-panel col-6">
        <div className="form-wrapper">
          <h2>Forgot Password</h2>
          <p className="login-title">
            Enter your email and we'll send you a link <br/> to get back into your
            account.
          </p>
          <p className="login-error">{apiError}</p>
          <p className="login-success">{apiResponse}</p>
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="form-group col-12 position-relative">
              <FontAwesomeIcon icon={faAt} className="signup-icons" /> 
                <label htmlFor="userName">Email</label>
                <input
                  id="userName"
                  className="form-control"
                  maxLength={60}
                  placeholder="Enter your email"
                  {...register("userName", {
                    required: "Please Enter Email",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter Email in correct format",
                    },
                  })}
                />
                {errors.userName && (
                  <small className="error">{errors.userName.message}</small>
                )}
              </div>
              <div className="form-group col-12">
                <label htmlFor="captchaText">Captcha Code</label>
                <input
                  id="captchaText"
                  placeholder="Enter Captcha Code"
                  maxLength={8}
                  className="form-control"
                  {...register("captchaText", {
                    required: "Please Enter Captcha Code",
                  })}
                />
                {errors.captchaText && (
                  <small className="error">{errors.captchaText.message}</small>
                )}
              </div>
              <div className="form-group col-6">
                <Captcha />
              </div>
            </div>
            <div className=" col-7 mx-auto">
              <button type="submit" className="login-btn">
                Reset Password Link
              </button>
            </div>
          </form>
          <div className="col-8 create-account">
              <Link to="/login">
              <ArrowBackIcon/> Back to Login
              </Link>
            </div>
        </div>
      </div>
      <BasicModal
        popupOpen={apiSuccessPopupOpen}
        bodyMessage={apiResponse}
        logo = {"/Images/succes-icon.png"}
        footer={{
          secondaryButton: {
            action: popupCloseHandler,
            buttonName: "OK",
          },
        }}
      />
    </div>
  );
};

export default ForgotPassword;